module.exports = __webpack_public_path__ + "static/img/aqzs36.5ec74033.jpg";